"use strict";
exports.__esModule = true;
exports.conferenceUrlType = exports.ConferenceServiceEnum = void 0;
var ZOOM_URL_REGEX = /((https|zoom):\/\/([^/]*\.)?)?(zoom|zoomgov)\.(us|com)\/(u|j|my)\/[^\s,&<>]*/g;
var MEET_URL_REGEX = /((https):\/\/)?meet\.google\.com\/[^\s,&]*/g;
var CODERPAD_URL_REGEX = /((https):\/\/)([^/]*\.)?coderpad\.io\/[^\s,&]*/g;
var CODESIGNAL_URL_REGEX = /((https):\/\/)([^/]*\.)?codesignal\.com\/[^\s,&]*/g;
var ConferenceServiceEnum;
(function (ConferenceServiceEnum) {
    ConferenceServiceEnum[ConferenceServiceEnum["Zoom"] = 0] = "Zoom";
    ConferenceServiceEnum[ConferenceServiceEnum["Meet"] = 1] = "Meet";
    ConferenceServiceEnum[ConferenceServiceEnum["Codesignal"] = 2] = "Codesignal";
    ConferenceServiceEnum[ConferenceServiceEnum["Coderpad"] = 3] = "Coderpad";
})(ConferenceServiceEnum = exports.ConferenceServiceEnum || (exports.ConferenceServiceEnum = {}));
/**
 * Try to match a conference url ANYWHERE in the passed in string.
 */
function parseConferenceUrl(potentialUrl, service) {
    if (!potentialUrl) {
        return null;
    }
    var regex;
    switch (service) {
        case ConferenceServiceEnum.Zoom:
            regex = ZOOM_URL_REGEX;
            break;
        case ConferenceServiceEnum.Meet:
            regex = MEET_URL_REGEX;
            break;
        case ConferenceServiceEnum.Coderpad:
            regex = CODERPAD_URL_REGEX;
            break;
        case ConferenceServiceEnum.Codesignal:
            regex = CODESIGNAL_URL_REGEX;
            break;
        default:
            throw new Error("No matching service supported for " + service);
    }
    var matches = potentialUrl.match(regex);
    return (matches === null || matches === void 0 ? void 0 : matches[0]) || null;
}
function conferenceUrlType(test) {
    var result;
    [
        ConferenceServiceEnum.Zoom,
        ConferenceServiceEnum.Meet,
        ConferenceServiceEnum.Codesignal,
        ConferenceServiceEnum.Coderpad,
    ].forEach(function (service) {
        if (parseConferenceUrl(test, service)) {
            result = service;
        }
    });
    return result;
}
exports.conferenceUrlType = conferenceUrlType;
exports["default"] = parseConferenceUrl;
//# sourceMappingURL=conference-urls.js.map